import { BrowserRouter } from 'react-router-dom';
import AppLayout from './app-layout/app-layout';
import { GlobalStyles } from './app.style';
import Main from './components/main/main';
import { DataProvider } from './shared/providers/data.provider';
import { ThemeProvider } from './shared/providers/theme-provider';

const baseUrl = `${process.env.PUBLIC_URL}`
export const baseImagesUrl = `${baseUrl}/assets/images`;


const App = () => {
    return (
        <BrowserRouter basename={baseUrl}>
            <GlobalStyles />
            <ThemeProvider >
                <DataProvider>
                    <AppLayout>
                        <Main />
                    </AppLayout>
                </DataProvider>
            </ThemeProvider>
        </BrowserRouter>
    )
};

export default App;